import { HttpLink } from "@apollo/client";

import { EHR_SERVICE_PATH } from "../../environments/environment";
import { createServiceBaseUrl } from "../../utils/createServiceBaseUrl";

import { getValidatedEndpoint } from "./utils/endpointHelper";

export const getHttpLink = (): HttpLink => {
  const serviceBaseUrl = sessionStorage.getItem("serviceBaseUrl");
  if (serviceBaseUrl) {
    return new HttpLink({
      uri: `${getValidatedEndpoint(serviceBaseUrl)}`,
      credentials: "same-origin",
    });
  } else {
    return new HttpLink({
      uri: `${createServiceBaseUrl()}${EHR_SERVICE_PATH}`,
      credentials: "same-origin",
    });
  }
};
